import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dymaczew/Documents/_code/mcm/cp4mcm-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Now that you have a ROKS cluster, you need to install manually the Cloud Pak for Multicloud Management. Let’s do it!`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Login to `}<a parentName="p" {...{
            "href": "https://cloud.ibm.com/catalog"
          }}>{`https://cloud.ibm.com/catalog`}</a>{` if you have not already`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the Catalog, select Cloud Pak for Multicloud Management`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACOElEQVQ4y5WSzUtUURiHL5SVKEJtdEaN0aj5zDHc1Kosh1oUSZv+gBY2oDC3IFq27v+IRkoJJEj3Uau2qaO2sBRy5n6ee8c7d/LpnGkmh0GDFj/e876c85z3S4vFYkQiEfoHIlyMp4gn0lxSiqdJJC+TymRlPE1X10lOnOqlO3aP7pFpei/c52x8mp7zU5wZuEZP/xVOn4ujJRIJRkdHuH7jJvNv3lGcX6RYXOD1/AJvF5dYer/Mq+Iid27nmLz7iNzTL+Sel8g9+8pU4TM5/ROT+RWuPnjJrYcv0MbGxohGo8zNzbH9/QdrpQ02tr5R2tyS2mRtvURJxnZ3d6lUDFzHpOq7UgJfKgxDdnZ2WFn+QD0M0FKpFBEJ1GdnkbeoWQZ1x6Jmm9RMA9+28HwfyzSxbRvHcXBdt01/fCFEw2rZbJbo0BD6zAyeG1KuCPbKAuHVOJAfVI0Krue1AUQH8FAKqmUyGSKDgzzJP2Z/P6Bs2ohqgB+EhME+VZmlKy+KjoedZ2VNWYWWSacbJSugfIVf2WuUfeAJflmm9MuNDMURgJaU78u2rK6uNjOUa6MXCjKjAMeycGWv/uoYSCdQWcMw0CYmJhiSPSwoYL2OozJRl9okmrF/wZT1ZCXa+Pj4IVCuQGuKok0t6NFAZQ+HpSWTyUbJncD/lYJ6oglUi63rOnVVsgS2fveEd2zfOuXIDA1Lrs3w8DB9fX3k83kCORSzbYF/yombckjKP06WZeMLm/Vth+JHn9/2a1B47S5ouQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "cp4mcm in catalog",
            "title": "cp4mcm in catalog",
            "src": "/cp4mcm-demohub/static/1cd5b4d68ef820fa205ce925c28dd2c8/a6874/2020-05-12-20-28-23.png",
            "srcSet": ["/cp4mcm-demohub/static/1cd5b4d68ef820fa205ce925c28dd2c8/7fc1e/2020-05-12-20-28-23.png 288w", "/cp4mcm-demohub/static/1cd5b4d68ef820fa205ce925c28dd2c8/a5df1/2020-05-12-20-28-23.png 576w", "/cp4mcm-demohub/static/1cd5b4d68ef820fa205ce925c28dd2c8/a6874/2020-05-12-20-28-23.png 840w"],
            "sizes": "(max-width: 840px) 100vw, 840px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the Redhat Openshift Cluster that you just created from the list. The DTE provisioned cluster name starts with dteroks or playgrowth. Select `}<strong parentName="p">{`kube-system`}</strong>{` as project name.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACkElEQVQ4y32TS08TURiG5x9oNIQoN7FcDJFCuZSmCkoQrCZWQWJIuFlaWhau1BgXLtgYE7du/A1IsC1CjPwG3bpwY9pOh7bTmWmnl5lp7es3p44WmniSN9+ZM/menHfeb7j1tcdYerSEleVVBANBbAY24ff54d/wIxQMIbQZwlZwC751H9ZW15n8GwHc8dxFZ3sX2i92oL2tA51tnUycKGYhywrS6TQymQztc1AUBZqm4X/r6MsRhgaHMDE+gbGRMQzbh9Fr6wWnyAUU1DKEpAAxI6JSqbCGWq2GarXaJEM32PvDg0OMOkYxfWMabpcbjiEH+nr6wCViCQh8Embl4zzSx2mIaRF5JY9SoYSiWjwhNacCv4BoOMogLqeL1YErA3Vg/GcMcYKZwOPkMQOaypF1C2hWa8+AtX/AqetTzLZpv7urG5yaoea8SrYLrKFcLDM1wsxayBfY3gJGCHh1wA7nGMHsDvTY+jA7MwfOvE2GpEhK3RY1Mp26mfVsWd6PRLHgvY2AbwUrS4uYv+fB7s4OOFnJQaKUVWrQNAO6QR++UkW5rJ+ANt60VgU+H3zC96970PM/kIp9o5h4vH/3FlwxkYAhijBoZBql0VmjZQtqWd6PRLDlX8b2q2d4+fwJXm+/wM1JN7g8z0PLZqFLEgxJ/iOJzqQm243A8F4EZ8+cQ2vLBaaW8624fMkGjucFJBJJCEIKoijRgItIpUQ24KcD+ZsyrejHMI1JP4XipLRHYB8cRn9vP7gYjY05MkmC8g3jI2flpkAYnIA1CmX3QxgjDidm57yYnJzBNfcUpT5IoZBFhUIxZf4FFaOCKoWinwqlDi5BL6oQJODpm314bk1jYX4RD7z3sTj/EOOj4/gNofg+xuo8nXMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "select project",
            "title": "select project",
            "src": "/cp4mcm-demohub/static/83bca83f604cb4472d8626bbf8efed5f/a6874/2020-05-12-20-47-59.png",
            "srcSet": ["/cp4mcm-demohub/static/83bca83f604cb4472d8626bbf8efed5f/7fc1e/2020-05-12-20-47-59.png 288w", "/cp4mcm-demohub/static/83bca83f604cb4472d8626bbf8efed5f/a5df1/2020-05-12-20-47-59.png 576w", "/cp4mcm-demohub/static/83bca83f604cb4472d8626bbf8efed5f/a6874/2020-05-12-20-47-59.png 840w"],
            "sizes": "(max-width: 840px) 100vw, 840px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You must run the preinstallation script before you install the Cloud Pak. There is no need to modify the content of the script, simply click on Run Script to complete the pre-installation step.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "842px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.208333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABoklEQVQoz42TyW7UQBCG/ag5RLwBlyAlNziCBPc8RE5EQkgoEkTKASEyQ8iNZWz34rjdq7f56argaFgipaVPVW13/f67q11oqVGXNUQlUG5KKKFgjb3DdQ7BhQdTyFqi/FmyKOULJEyxbVpe6K1/EIWSip21Ny2GfsA4jAzlRJ96xBCZFBLPl3e70HN26KxDVVVQSkFrDSEE58YYdF0Hay2GIRf0PbPdbnHfoHUFFZJgXdeMqAWklAx9gARjjJjnmVkEKe5CYxqnW4fkqGkajt77vL3AkQg+H3aepyyaUvpHaNcxC1IBuXDOcdx1cd+YpumPNVQzzdNvh/kg6axiduOyoHd0TTw3hormXPw/qHgcRxanhtnOcmMKuEvEmzV0+QWNuILTV7D6K/TmE+SPjzD1JZxaw8o1OrHi2JtrJNfkaxL5qlB3o7/Ni+vVOc7PXuPiwzus3r/FxZsTfD47hZHfYNR3+HaD2FVMMCXHZPPcmSwQeDd39zDnxYvnL7G3t4+jg0McP32Gx/uP8OrgCUJHzRlyQcoLE8cFmi9if/8pvwAnvUZzt5aENQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "run script",
            "title": "run script",
            "src": "/cp4mcm-demohub/static/04beae5cc96f57d63bbbe1f155234cd1/60ef9/2020-05-12-20-49-57.png",
            "srcSet": ["/cp4mcm-demohub/static/04beae5cc96f57d63bbbe1f155234cd1/7fc1e/2020-05-12-20-49-57.png 288w", "/cp4mcm-demohub/static/04beae5cc96f57d63bbbe1f155234cd1/a5df1/2020-05-12-20-49-57.png 576w", "/cp4mcm-demohub/static/04beae5cc96f57d63bbbe1f155234cd1/60ef9/2020-05-12-20-49-57.png 842w"],
            "sizes": "(max-width: 842px) 100vw, 842px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Once the pre-installation step is complete, you may proceed with the installation.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "863px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "10.416666666666668%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAAsSAAALEgHS3X78AAAAeElEQVQI102Myw6CMAAE+f9PI9IYW1oeBbREWywxeBCOIzaaeNjMTjbZLI8KMRmKoeRwPiGcorhI1NQifY2ZO/TdJprYJarQoL/dzH1K9Ri4rpGsWCrkYslvFhH2Y18ivOYY6901+tnTriPNy9F8+Ot/nvZtxG2BN1+ykJ154ptnAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "pre-req completed",
            "title": "pre-req completed",
            "src": "/cp4mcm-demohub/static/67a246f305419358adfee85d748fa66c/26f46/2020-05-12-20-51-05.png",
            "srcSet": ["/cp4mcm-demohub/static/67a246f305419358adfee85d748fa66c/7fc1e/2020-05-12-20-51-05.png 288w", "/cp4mcm-demohub/static/67a246f305419358adfee85d748fa66c/a5df1/2020-05-12-20-51-05.png 576w", "/cp4mcm-demohub/static/67a246f305419358adfee85d748fa66c/26f46/2020-05-12-20-51-05.png 863w"],
            "sizes": "(max-width: 863px) 100vw, 863px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter a value for defaultAdminPassword. It is important that you choose a password that is 32 characters in length and conforms to the password rule: include only numbers, letters or ’-‘.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "818px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "26.73611111111111%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVQY021Q7Q6CMAzk/R9QI/BbJmGEofted65TiBGaNF137V3bRkoJIR4Qg8BwH8B5DBGb5ZwPfobhGxvvPbTWCCFU5zzGuPuZERGs84f/SmiMwTRNlSyltIOznDGOI6y14BqOLMw1sYg+5xnEPc4hlZxKpII1zMqKPA0XbysppeoZWIzf67pCLQsiFVy/4NobdN/BdC1M38NeL4XUfgg3kt+bMHkVoHy6Wi5D/N+WB3sDhUqHUlzO0BUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "password",
            "title": "password",
            "src": "/cp4mcm-demohub/static/99f376873532a0e85b02d60ddd5bfc89/96d67/2020-05-12-20-54-44.png",
            "srcSet": ["/cp4mcm-demohub/static/99f376873532a0e85b02d60ddd5bfc89/7fc1e/2020-05-12-20-54-44.png 288w", "/cp4mcm-demohub/static/99f376873532a0e85b02d60ddd5bfc89/a5df1/2020-05-12-20-54-44.png 576w", "/cp4mcm-demohub/static/99f376873532a0e85b02d60ddd5bfc89/96d67/2020-05-12-20-54-44.png 818w"],
            "sizes": "(max-width: 818px) 100vw, 818px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Accept license agreement and click `}<strong parentName="p">{`Install`}</strong>{` to install Cloud Pak for Multicloud Management. The installation takes about 30 minutes.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "377px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.76388888888889%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB6klEQVQoz52RS2/TQBSF/StQN32kJH4nsWPHHntsJ03ipIWKLoqEkICqtFEfiMatk9IWoSIKK1QktvzZw8zE6UtiQRefz71XZ47v2FLgBygvlyGXZaiy+mg0RYNSUSCZugm/6aNhNcRwhq7q9/TufAbvZ4E8TATOPZnD9c9r5Mc5HNtBd6ULGlD0Oj1ENEYSJRikA6TdFK24hXbSFh7Oan9VEDMfv6UI5Fc1NAP1ag1RSEUAV36QG2MaidpzvekWzD/bZnpVBlO5mEv8wdNVWQPxKYhHEAZss7iNgIRiFhAK23LEIU01mVcvQtUb7gWqDF010PD6sNwV2M0ObFZXrQh1pyVqhwzg0XW4TB3ShxdvwItewA3WYDkJ1HJF5LArK5gvPcXiMnu704HppdAaLRjNFFXyDLrbgd7sQbUTVAwX84slLCxxf0XA64XSlCXWS6asYJt4eBcGjLDQAFvs221ReqenRU+KGbmp3wYEOzTEhm1B8hUFf3a3cXmS42o0wlWW4RvTW7KCh/0tl0cj/BqP8XV9DZLHNvyx8x4fz79gfPYZ2eQMh6MTfMhyHD7gX7N95p9MPiF/zgPZhr/fvMbp3j4uhkOcP4LT3SG+HxzgYpBC0tmf2bRqeGnVhW4K/V9qeGXX0TNN/AUFe6eBvaQjZwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "accept license",
            "title": "accept license",
            "src": "/cp4mcm-demohub/static/a37f587846deb370f64c24cab697302f/e27b9/2020-05-12-21-02-48.png",
            "srcSet": ["/cp4mcm-demohub/static/a37f587846deb370f64c24cab697302f/7fc1e/2020-05-12-21-02-48.png 288w", "/cp4mcm-demohub/static/a37f587846deb370f64c24cab697302f/e27b9/2020-05-12-21-02-48.png 377w"],
            "sizes": "(max-width: 377px) 100vw, 377px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <p parentName="li">{`You can track the deployment on the Schematics workspace that opens.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "29.166666666666668%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABIUlEQVQY05XPvU7CUBTA8T6jKUiwrUYpPIKjr+DAQjRORgdXRjefwwShQLltoaW3twVa/l6oiWEyDr+cj5ycnGNcOdecN1s4lk3P7dLruDq6dDudY+5e3+BcWDRNk0ajzZnp0Go5mA0bs3mpo4VjO8cZu21hjCZTPC9kcjAN+RwJpn7CKtmSpBVjL2Lw8EK/P+BpOObuDV4/dtwPS26fSx7fS+KkYB5tSOUOY+J9MZ8H+IuYIJIsAkm4VL8ihS8SZn6MCDPEoQ61QDETSvcUq1jHICVerjEiEZIma+RakquCTa5gX51iXzvp/dD5XtstfHIhMI6LZI6UUr8Yk+p6u91RVRVVWSv/UM+U+pgCQ0lFlmZksqYyRaEv/Te9LM9yvgG6fqYiRCx/gAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "schematics",
            "title": "schematics",
            "src": "/cp4mcm-demohub/static/5ed0664c1db29f474d4ba9287a960f7a/a6874/2020-05-12-21-00-21.png",
            "srcSet": ["/cp4mcm-demohub/static/5ed0664c1db29f474d4ba9287a960f7a/7fc1e/2020-05-12-21-00-21.png 288w", "/cp4mcm-demohub/static/5ed0664c1db29f474d4ba9287a960f7a/a5df1/2020-05-12-21-00-21.png 576w", "/cp4mcm-demohub/static/5ed0664c1db29f474d4ba9287a960f7a/a6874/2020-05-12-21-00-21.png 840w"],
            "sizes": "(max-width: 840px) 100vw, 840px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.76388888888889%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABn0lEQVQoz3VSiW7CMBTjOzdN4po2YPtkikRpSym9L3p6z4+rsK2S9ZKX1LGdjCbjGSbjOV5f3jCfvmO1+BZ84Wu5wvJzqVgtVlh8LDCdzBTz6fxcZ++PvfEUoyTO4dgewjDFqWxRCuqqRVvf0TWd4t5rtDaXOsQoSWMURY6+6wUdsixDLuDmTuZN0yCOY+nlt17XntG27Q2cV2UlhEkCz/OQxAnSNEUYhMjSDEVeyEGFKC61z33alx7X8jwXRyddL4sSdV3rfBSFEQzDgLk1Yds2HMfB4XCA67rwj76OgyBQwuuhVEyQvO97Vc1aVzUzTLDb7eAdPOz3e1iWJXmGqpRrJKqqCsOPP18x/BiJKlyv10JqYbvd4ng8IooiJaUKktGOWjqdtP5F/kBorA1YQmiapubp7l2tvu+rXRKragEzeyZ6IIyjGJvNBrZlq/XAD/RHWtXgRdXtZi9ZPZM9ED5nyIuhMgZOe3w2z1kN7f5SSMKhVY6pkNldM+PtccwewUOo9k+FN8uijDnyuTi2o6p5Qfr+svP7I9n1If9n+QeqgH8NbrSbAAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "log",
            "title": "log",
            "src": "/cp4mcm-demohub/static/c24bdec4cd19c62f45d651d08bbb2832/a6874/2020-05-12-21-06-11.png",
            "srcSet": ["/cp4mcm-demohub/static/c24bdec4cd19c62f45d651d08bbb2832/7fc1e/2020-05-12-21-06-11.png 288w", "/cp4mcm-demohub/static/c24bdec4cd19c62f45d651d08bbb2832/a5df1/2020-05-12-21-06-11.png 576w", "/cp4mcm-demohub/static/c24bdec4cd19c62f45d651d08bbb2832/a6874/2020-05-12-21-06-11.png 840w"],
            "sizes": "(max-width: 840px) 100vw, 840px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Your cluster domain can be found in multiple places, for example at the end of installation log file.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1115px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "13.88888888888889%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAtUlEQVQI102PwW6DMBBE8/8/VrWqVPUCpQmpgwMYk4BjBxci7FeTU0d6mjmsdjS7siioK4koS7q2ZTSG6T4RYoRfD87B3RGdJdgbMfHf13EkbHdJa4jsfl5fqD8/qN7fuMgK3fecpaTrFLrco74ymjxDFTmjOGJOguvx8MzuLJlVQ0hlm8L2MMu/Eaea/UEgqoa61XR6oL8a+sGiE+piGKzH+uXJbZoTC/4ReKQh8wpLyn4O/AEoUOJh9T2lcwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "output parameters",
            "title": "output parameters",
            "src": "/cp4mcm-demohub/static/8f5876e6f5d08551f7d32fba700aa15b/c8ede/2020-05-12-21-23-09.png",
            "srcSet": ["/cp4mcm-demohub/static/8f5876e6f5d08551f7d32fba700aa15b/7fc1e/2020-05-12-21-23-09.png 288w", "/cp4mcm-demohub/static/8f5876e6f5d08551f7d32fba700aa15b/a5df1/2020-05-12-21-23-09.png 576w", "/cp4mcm-demohub/static/8f5876e6f5d08551f7d32fba700aa15b/c8ede/2020-05-12-21-23-09.png 1115w"],
            "sizes": "(max-width: 1115px) 100vw, 1115px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <p parentName="li">{`However the easiest way is to click `}<strong parentName="p">{`Offering dashboard`}</strong>{` at the top of the Schematics workspace`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "839px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "26.38888888888889%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAABDElEQVQY022Oy0rDUBCG84jSVhNL04ta9VlcKKJbwYJ7QcSlbyC4EnQjbTWtSXNyOec0NGn6maZFKQrz8c/8c2GMZqNFp72PZVq0my2Ou4c/HHW7pR509qhbFrVqjcp2k+pOC9O0qVRttio29d1GuWvXbQwhQoafE/pDwfBjwvtgicfYVYgwRU3h6fmN84sreje3XD5knNzB/aPPWe+L02uXl9cYEaVonWL0Bw4jZ4wz8nG9CM/XTAr8YFoi1rr0RaDL2hPJqi+mhOFqRhQqI4kxclx8z0fHChnHKB2TzmawyDdhUcTir78mz3OSZIahikNaahKVIKUkiAKUVGRZxnw+/yX7J9/QvHgk5RsGnFje1QkdMwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "offering dashboard",
            "title": "offering dashboard",
            "src": "/cp4mcm-demohub/static/7b37e6e112f693c9e1c6a51d36fb74e7/b6bf4/2020-05-12-21-25-47.png",
            "srcSet": ["/cp4mcm-demohub/static/7b37e6e112f693c9e1c6a51d36fb74e7/7fc1e/2020-05-12-21-25-47.png 288w", "/cp4mcm-demohub/static/7b37e6e112f693c9e1c6a51d36fb74e7/a5df1/2020-05-12-21-25-47.png 576w", "/cp4mcm-demohub/static/7b37e6e112f693c9e1c6a51d36fb74e7/b6bf4/2020-05-12-21-25-47.png 839w"],
            "sizes": "(max-width: 839px) 100vw, 839px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login to Cloud Pak interface using icp-console.`}<em parentName="p">{`yourcluster-domain-name`}</em>{`. Provide `}<strong parentName="p">{`admin`}</strong>{` and the password that you specified in step 6 above.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACaklEQVQ4y22TWW8TMRSF5x/zzg9A4pVXEE8gFgWRQBESpS0lbUhb2qRps7RpmnSy75nMxOtkDteehIaKkY5sj+3vnmtfOz5bYuqTgiUC/q8WIsJkpjCaKAzGCsOVzNhoMtOY+xrjaTwek5xiQ+PFFserbY4JgYWOwGT0FzgYKSvGQkymGt2+Qrsr0SL1BgqzeWjnu30zlnDG3hJuT1v1J7RhpDGchhZm1BvG0f0gBOMRgTSqdYmbhkSVVKkJ1F0Jty3RaBFw5ofoDAW6Q4pA6XSNIwMgR8Zpq6dQqgocF4Rtz8sCuZJAvhT3600FTVmNyf31rYDjU2reIoLHgAj3n1yCgEvUKHquyHFR4fh9wZE547i8kigQ7FeOE5TcdRRuaV3xmoBue4Sd3TR29tLY/XGI/XSW+gfIFyp0nkCFombOGDniVrtZjqMcOc4L7FG/RJDiNUc2z3BEcq6qLt6+SyCV+oJk8jOSqS0kEh9xcHgEFQL5MsfX/QBVArstgW9phjcpjtdJ0ieGyo1AwxX4eczwPbOAY87pfx9lDK4ilGvx4nKV243PP3h49HSAx898PHnJcFJgcJsCp5fGJYfjBZLKwYfnc6opjoApKB0ioji2HplGsNC2Hgd047U7OoLTOY7POd2wRLMjaL+ClCG4COHY8rCFHNqbDcnaSXGE99t1CAWaCyFVvFjQJm+uCazR68eFbP4xWjNeQZ11ARuZPidIs89QrM1s2fjkUNDt1Cmt2VxZuL+IX4gJYmQyMC/IOnz41ExrnOnlfcqcgB4BGI+1Bm2OY6d6lfKGw3UbK7JAs1A8gGzCNvt/AJMv0TTGKiEVAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "login",
            "title": "login",
            "src": "/cp4mcm-demohub/static/42db5bc5b9d767c6241b22cecffe5480/a6874/2020-05-12-21-28-45.png",
            "srcSet": ["/cp4mcm-demohub/static/42db5bc5b9d767c6241b22cecffe5480/7fc1e/2020-05-12-21-28-45.png 288w", "/cp4mcm-demohub/static/42db5bc5b9d767c6241b22cecffe5480/a5df1/2020-05-12-21-28-45.png 576w", "/cp4mcm-demohub/static/42db5bc5b9d767c6241b22cecffe5480/a6874/2020-05-12-21-28-45.png 840w"],
            "sizes": "(max-width: 840px) 100vw, 840px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You have successfully completed cluster provisioning, Cloud Pak for Multicloud Management installation. You are ready to proceed to tutorials that use Cloud Pak for Multicloud Management on ROKS, or install other tools if desired.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "840px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACY0lEQVQ4y3VSPW8TQRC9v0dJgRA1pRPspLCRjY2IgAaJLjS0VAiJlopIoAQkGkhix0lwbN/5Puz72vu+i20es3O2RUCc9HQ7b2d3Z948pd1uo91+hE6ng1arhVqthmq1uoGM19jefoDK1hZqOzto1OuoVGpoNB6i2Wxid3cXdeKUIIoQJwmiOEEQRpjPF/jfd017cVrA9z18/XaGdwfAxyMVpqHx/mKxgDJSNYw1Dao2wXCsQpvomBgGx2Pac10PYRgiDALYjgMviLH39Bnu3L2H569+4Nbt+9jbe4woiiGEgHLc7eG4e4bvJ12c9M7Q7Z/z/7TXZ26iG0ioA3lpQJcK6uLz4RH2X7/FizcJnrz8gC+Hnygn5X3F9TyuwnZcakUgjuN/kKZSkhi6ZRNmcEUAx0/w/sCEZmXArwVXKHOVNM1xXRQoVsjzApIripzWJbKsIJ1pnWVIJdKUkGG5kGdTJBRnxLOGQoSbdiI5IBqO51NrFEs+jktOBGVOycU8RNdbnQ3L/3w+h3I5GEA3TExnNifKjcHVkIfik8iyGnn55eCKhjfhPNY0CjFSVeYM0+JzXOFY02FNZ/A8b/P6zHbhuC5PjR+hyieGBdOacu7NPI8721Qowpx0WelFOmSkIXNpzrpkf3F5TrHUkM74YUb6lbGserlckrGpHbYDVVNqVMZ/8jJ5PSCJQmIzxPwGlP7FBfrnF+iR/66GpJ00OmmjktkNMriu62Qrl3VWyfSsI7UtLSYtJ0Q5zDWU49MuJC5/Dvii0WjMkBdbFulmmnTYZ6/ObJth2w4c8q1c++Kmd38DpDqyP8MPgJwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "welcome page",
            "title": "welcome page",
            "src": "/cp4mcm-demohub/static/5563b1c2ed6bd227610c00ba754bc01e/a6874/2020-05-12-21-31-32.png",
            "srcSet": ["/cp4mcm-demohub/static/5563b1c2ed6bd227610c00ba754bc01e/7fc1e/2020-05-12-21-31-32.png 288w", "/cp4mcm-demohub/static/5563b1c2ed6bd227610c00ba754bc01e/a5df1/2020-05-12-21-31-32.png 576w", "/cp4mcm-demohub/static/5563b1c2ed6bd227610c00ba754bc01e/a6874/2020-05-12-21-31-32.png 840w"],
            "sizes": "(max-width: 840px) 100vw, 840px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      